// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import './ButtonGroup.less';

/**
 * `ButtonGroup` component is used for visual grouping of several [Buttons](#!/Button) together. Buttons are typically grouped
 * based on the similarity of their actions -- for example, for visually separating buttons that add new elements to the list
 * from buttons that modify existing elements in the list.
 */
const ButtonGroup = ({ baseClassName, className, children, innerRef, ...props }) => (
    <div className={classNames(baseClassName, className)} ref={innerRef} {...props}>
        {children}
    </div>
);

ButtonGroup.propTypes = {
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * Content of the button group
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    innerRef: PropTypes.func,
};
ButtonGroup.defaultProps = {
    baseClassName: `${CLS_PREFIX}button-group`,
    className: null,
    children: null,
    innerRef: null,
};

export default ButtonGroup;



// WEBPACK FOOTER //
// ./components/ButtonGroup/ButtonGroup.js